import { CALENDAR_CONSTANTS } from './calendar-constants';
/** Finds the most recent day before `startIndex` that can be selected. */
export function findPreviousEnabledDay(dates, startIndex) {
    for (var i = startIndex; i >= 0; i--) {
        var day = dates[i];
        if (day.isThisMonth && !day.disabled) {
            return i;
        }
    }
    return -1;
}
/** Finds the next available day from `startIndex` that can be selected. */
export function findNextEnabledDay(dates, startIndex) {
    for (var i = startIndex + 1; i < dates.length; i++) {
        var day = dates[i];
        if (!day.isThisMonth) {
            break;
        }
        else if (!day.disabled) {
            return i;
        }
    }
    return -1;
}
/** Converts a 1D index to 2D coordinates. */
export function getDateCoordsFromIndex(index) {
    return [Math.floor(index / 7), index % 7];
}
/** Gets the first selectable day from the provided dates. */
export function getFirstActiveDayIndex(dates) {
    return dates.findIndex(function (d) { return d.isThisMonth && !d.disabled; });
}
/** Gets the last selectable day from the provided dates. */
export function getLastActiveDayIndex(dates, startIndex) {
    startIndex = startIndex !== undefined ? startIndex + 1 : undefined;
    return (dates.length - 1) - dates.slice(0, startIndex).reverse().findIndex(function (d) { return d.isThisMonth && !d.disabled; });
}
/** Gets the previous date index based on direction. */
export function getPreviousDayIndex(direction, index) {
    return direction === 'vertical' ? index - 7 : index - 1;
}
/** Gets the next date index based on direction. */
export function getNextDayIndex(direction, index) {
    return direction === 'vertical' ? index + 7 : index + 1;
}
/** Returns the requested date from the provided dates by index, or null if not available. */
export function getActiveDay(dates, index) {
    return index !== null ? (dates[index] || null) : null;
}
/** Returns the currently active day as a tuple in format of [rowIndex, colIndex]. */
export function getActiveDateIndex(dates, index, selectedDateCount) {
    if (index >= 0) {
        return index;
    }
    if (selectedDateCount) {
        return (dates.length - 1) - dates.slice().reverse().findIndex(function (d) { return d.isSelected; });
    }
    return dates.findIndex(function (d) { return d.isToday; });
}
/** Sets date attributes on a td element */
export function setDateAttributes(date, element, weekIndex, dateIndex) {
    var eventLabels = date.events.map(function (event) { return event.label; }).filter(function (label, index, self) { return self.indexOf(label) === index; }).join(', ');
    element.id = "date-day-" + weekIndex + "-" + (dateIndex - 1);
    element.tabIndex = date.isSelected ? 0 : -1;
    element.setAttribute('role', 'gridcell');
    element.setAttribute('aria-selected', date.isSelected.toString());
    element.setAttribute('aria-disabled', date.disabled.toString());
    element.setAttribute('aria-label', "" + date.date.toLocaleDateString(undefined, { month: 'long', day: '2-digit', year: 'numeric' }) + (eventLabels.length ? ': ' + eventLabels : ''));
    element.setAttribute(CALENDAR_CONSTANTS.attributes.DATA_DATE, date.date.toString());
}
/** Sets date classes a td element */
export function setDateClasses(date, element, displayOnly) {
    element.classList.add(CALENDAR_CONSTANTS.classes.DATE);
    if (date.isToday) {
        element.classList.add(CALENDAR_CONSTANTS.classes.TODAY);
    }
    if (!displayOnly && date.isSelected) {
        element.classList.add(CALENDAR_CONSTANTS.classes.SELECTED);
    }
    if (date.disabled) {
        element.classList.add(CALENDAR_CONSTANTS.classes.DISABLED);
    }
    else if (!displayOnly) {
        element.classList.add(CALENDAR_CONSTANTS.classes.INTERACTIVE);
        element.addEventListener('click', function () { return date.onSelect(date); });
    }
}
/** Append date content to a td element */
export function appendDateContent(date, element) {
    var textWrapperDiv = document.createElement('div');
    textWrapperDiv.classList.add(CALENDAR_CONSTANTS.classes.DATE_WRAPPER);
    var text = document.createElement('span');
    text.textContent = date.date.getDate().toString();
    textWrapperDiv.appendChild(text);
    element.appendChild(textWrapperDiv);
}
/** Appends event indicators to a td element */
export function appendEvents(date, element) {
    if (date.events.length) {
        var eventWrapperDiv_1 = document.createElement('div');
        eventWrapperDiv_1.classList.add(CALENDAR_CONSTANTS.classes.EVENT_WRAPPER);
        date.events.forEach(function (event, eventIndex) {
            // Show no more than 3 events, the third replaced with + if there are more
            if (eventIndex > 2) {
                return;
            }
            var icon = document.createElement('tcw-icon');
            icon.classList.add(CALENDAR_CONSTANTS.classes.EVENT);
            if (eventIndex === 2 && date.events.length > 3) {
                icon.setAttribute('name', 'add');
                icon.classList.add(CALENDAR_CONSTANTS.classes.ADDITIONAL_EVENTS);
            }
            else {
                var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" stroke="var(--mdc-theme-surface)" stroke-width="4px" paint-order="stroke"></path></svg>';
                icon.setAttribute('src', svg);
                icon.setAttribute(CALENDAR_CONSTANTS.attributes.DATA_EVENT_THEME, event.color);
            }
            eventWrapperDiv_1.appendChild(icon);
        });
        element.appendChild(eventWrapperDiv_1);
    }
}
